import { Box, Slider } from "@mui/material";
import React from "react";

const Sliders = () => {
	return (
		<Box>
			<Slider
				size="small"
				defaultValue={70}
				aria-label="Small"
				valueLabelDisplay="auto"
				color="secondary"
			/>
			<Slider defaultValue={50} aria-label="Default" valueLabelDisplay="auto"/>
		</Box>
	)
}

export default Sliders;